import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {CustomizedItemModel} from "../models/domain/customizedItemModel";

export const useCustomizedItemQuery = () => {
    const {model: {customizedItem}} = useProductDetailsQuery();
    return {model: new CustomizedItemModel(customizedItem)};
}